<template>
  <div class="page">
    <div class="m-b-24 bg-content padding15">
      <el-form size="small" label-width="80px">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="公司">
              <el-select v-model="company.companySelected" filterable placeholder="请选择" style="width: 100%;" @change="companyChange">
                <el-option v-for="item in company.companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="策略组">
              <el-select v-model="group.groupSelected" placeholder="请选择" style="width: 80%;" @change="groupChange" filterable>
                <el-option
                  v-for="item in group.groupOption"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="text right">
              <el-dropdown trigger="click">
                <el-button type="primary" size="small">
                  策略模板设置<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item @click.native="strategyConfig" v-if="this.$hasPerm('B031')">策略配置</el-dropdown-item> -->
                  <el-dropdown-item @click.native="addStrategy(null)" v-if="this.$hasPerm('B032')">添加策略组</el-dropdown-item>
                  <el-dropdown-item @click.native="updateStrategyVisible = true" v-if="this.$hasPerm('B025')">更新策略和模板</el-dropdown-item>
                  <el-dropdown-item @click.native="addTemplate">创建模板</el-dropdown-item>
                  <el-dropdown-item @click.native="updateTemplateVisible = true" v-if="this.$hasPerm('B027')">批量更新模板</el-dropdown-item>
                  <el-dropdown-item @click.native="groupConfig" v-if="this.$hasPerm('B031')">策略组配置</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bg-content padding15">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="策略总览" name="策略总览">
          <strategy-overview ref="strategyOverview" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" @refreshList="onRefresList" @updateGroup="updateGroup" @strategyRouteConfig="strategyRouteConfig"></strategy-overview>
        </el-tab-pane>
        <el-tab-pane label="策略明细" name="策略明细" v-if="this.$hasPerm('B008&7')">
          <send-rule ref="sendRule" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :labelOption="labelOption" :templateMsgOption="templateMsgOption" :templateVoiceOption="templateVoiceOption" :templateIVoiceOption="templateIVoiceOption" :templateSVoiceOption="templateSVoiceOption"></send-rule>
        </el-tab-pane>
        <el-tab-pane label="语音模板列表" name="语音模板列表" v-if="this.$hasPerm('B008&1')">
          <voice-template-list ref="voiceTemplateList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :initTemplateFiled="initTemplateFiled" :addOrEditTemplate="addOrEditTemplate" :deleteTemplate="deleteTemplate" :openAndCloseTemplate="openAndCloseTemplate"></voice-template-list>
        </el-tab-pane>
        <el-tab-pane label="智能语音模版" name="智能语音模版" v-if="this.$hasPerm('B008&1')">
          <ivoice-template-list ref="ivoiceSceneTemplateList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :companyAmount="this.company.amount" :initTemplateFiled="initTemplateFiled" :addOrEditTemplate="addOrEditTemplate" :deleteTemplate="deleteTemplate" :openAndCloseTemplate="openAndCloseTemplate"></ivoice-template-list>
        </el-tab-pane>
        <el-tab-pane label="短信模板列表" name="短信模板列表" v-if="this.$hasPerm('B008&2')">
          <msg-template-list ref="msgTemplateList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :initTemplateFiled="initTemplateFiled" :addOrEditTemplate="addOrEditTemplate" :deleteTemplate="deleteTemplate" :openAndCloseTemplate="openAndCloseTemplate"></msg-template-list>
        </el-tab-pane>
        <el-tab-pane label="挂短模板列表" name="挂短模板列表" v-if="this.$hasPerm('B008&14')">
          <hangup-template-list ref="hangupTemplateList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected"></hangup-template-list>
        </el-tab-pane>
        <el-tab-pane label="对话语音场景" name="对话语音场景" v-if="this.$hasPerm('B008&6')">
          <voice-scene ref="voiceScene" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected"></voice-scene>
        </el-tab-pane>
        <el-tab-pane label="场景模板" name="场景模板" v-if="this.$hasPerm('B008&8')">
          <scene-template ref="sceneTemplate"  v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :initTemplateFiled="initTemplateFiled" :addOrEditTemplate="addOrEditTemplate" :openAndCloseTemplate="openAndCloseTemplate" :openAndCloseSceneTemplate="openAndCloseSceneTemplate"></scene-template>
        </el-tab-pane>
        <el-tab-pane label="场景流程" name="场景流程" v-if="this.$hasPerm('B008&9')">
          <panel ref="panel" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected"></panel>
        </el-tab-pane>
        <el-tab-pane label="模板关键字列表" name="模板关键字列表" v-if="this.$hasPerm('B008&10')">
          <template-filed ref="informationFields" @showbox="toshow" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected"></template-filed>
        </el-tab-pane>
        <!-- 关键字音频已移至系统配置菜单 -->
        <el-tab-pane label="标签列表" name="标签列表" v-if="this.$hasPerm('B008&3')">
          <label-list ref="labelList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :caseStatusOption="caseStatusOption" :contactStatusOption="contactStatusOption" :labelMainOption="labelOption" :getLabelParams="getLabelParams"></label-list>
        </el-tab-pane>
        <el-tab-pane label="案件状态" name="案件状态" v-if="this.$hasPerm('B008&4')">
          <case-status ref="caseStatus" v-bind:changeTabe="activeTab" :getCaseStatusParam="getCaseStatusParam" :caseStatusOption="caseStatusOption"></case-status>
        </el-tab-pane>
        <el-tab-pane label="联系人状态" name="联系人状态" v-if="this.$hasPerm('B008&5')">
          <contact-status ref="contactStatus" v-bind:changeTabe="activeTab" :getContactStatusParam="getContactStatusParam" :contactStatusOption="contactStatusOption"></contact-status>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="dialog">
      <!-- 策略配置弹窗 -->
      <el-dialog
        title="策略配置"
        :visible.sync="strategyConfigVisible"
        width="70%" ref="strategyConfigVisible">
        <div>
          <el-form size="small" label-width="100px">
            <template v-for="(item, index) in groupList">
              <template v-if="item.isMain == 1">
                <el-row class="sc-row" :gutter="25" :key="generator('mainStrategy',index)">
                  <el-col :span="5" class="sc-row__title">
                    <strong>{{item.groupName}}</strong>
                  </el-col>
                  <el-col :span="4" class="sc-row__title">
                    <el-form-item label="发送比例(%)">
                      <el-input  v-model="item.percentage" class="percent" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__title">
                    <el-form-item label="首发方式">
                      <el-select size="small" class="percent" v-model="item.sendWay" @change="changeSendWay(item)">
                        <el-option
                          v-for="item in firstSendWays"
                          :key="item.ccChannel"
                          :label="item.channelName"
                          :value="item.ccChannel">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__title">
                    <el-form-item label="首发模版">
                      <el-select size="small" class="percent" v-model="item.sendTemplateId" clearable filterable>
                        <el-option
                          v-for="m in item.templateList"
                          :key="m.id"
                          :label="m.name"
                          :value="m.id">
                          <template>
                            <el-tooltip placement="top" effect="light">
                              <div slot="content" v-html="m.contentShow === undefined || m.contentShow === null ? m.content : m.contentShow"></div>
                              <span>{{m.name}}</span>
                            </el-tooltip>
                          </template>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <template v-else-if="item.isMain == 2">
                <el-row class="sc-row" :gutter="24" :key="item.id">
                  <el-col :span="4" class="sc-row__title">
                    <strong>{{item.groupName}}</strong>
                  </el-col>
                  <el-col :span="18" class="sc-row__content">
                    <div class="send-percent">
                      <label>发送比例(%)：</label>
                      <el-input v-model="item.percentage" class="percent" size="small"></el-input>
                      <el-button type="primary" size="small" plain>调整评分区间</el-button>
                      <el-button type="primary" @click="addStrategyConfig(item)" size="small" plain>+</el-button>
                    </div>
                    <div class="score-table">
                      <table class="table border bordered">
                        <thead>
                        <th style="width: 300px;">评分区间</th>
                        <th>策略组</th>
                        <th>操作</th>
                        </thead>
                        <tbody>
                        <template v-for="(scoreItem, index) in scoreConfList">
                          <template v-if="scoreItem.type == 0">
                            <tr :key="generator('scoreSelect',index)">
                              <td>其它评分</td>
                              <td>
                                <el-select size="small" v-model="scoreItem.groupId">
                                  <el-option
                                    v-for="item in group.groupOption"
                                    :key="item.id"
                                    :label="item.groupName"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                              </td>
                              <td>
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr :key="generator('scoreSelect',index)">
                              <td>
                                <el-slider
                                  v-model="scoreItem.strategyScore"
                                  range
                                  :min="0"
                                  :max="100">
                                </el-slider>
                              </td>
                              <td>
                                <el-select size="small" v-model="scoreItem.groupId">
                                  <el-option
                                    v-for="item in group.groupOption"
                                    :key="item.id"
                                    :label="item.groupName"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                              </td>
                              <td>
                                <el-button type="danger" @click="deleteStrategyConfig(scoreItem,index)" size="mini" icon="el-icon-delete" plain></el-button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <el-row class="sc-row" :gutter="24" :key="generator('otherStrategy',index)">
                  <el-col :span="5" class="sc-row__title">
                    <el-input v-model="item.groupName" style="width: 120px;"></el-input>
                  </el-col>
                  <el-col :span="4" class="sc-row__content">
                    <el-form-item label="发送比例(%)">
                      <el-input  v-model="item.percentage" class="percent" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__content">
                    <el-form-item label="首发方式">
                      <el-select size="small" class="percent" v-model="item.sendWay" @change="changeSendWay(item)">
                        <el-option
                          v-for="item in firstSendWays"
                          :key="item.ccChannel"
                          :label="item.channelName"
                          :value="item.ccChannel">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__content">
                    <el-form-item label="首发模版">
                      <el-select size="small" class="percent" v-model="item.sendTemplateId" clearable filterable >
                        <el-option
                          v-for="m in item.templateList"
                          :key="m.id"
                          :label="m.name"
                          :value="m.id">
                          <template>
                            <el-tooltip placement="top" effect="light">
                              <div slot="content" v-html="m.contentShow"></div>
                              <span>{{m.name}}</span>
                            </el-tooltip>
                          </template>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__content">
                    <el-button @click="delStrategyGroup(item.id)" size="small">删除</el-button>
                    <el-button type="primary" @click="synStrategy(item.id)" size="small">同步到主策略</el-button>
                  </el-col>
                </el-row>
              </template>
            </template>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="strategyConfigVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveStrategyConfig" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 策略组路由弹窗 -->
      <el-dialog
        title="路由策略组配置"
        :visible.sync="strategyRouteConfigVisible"
        width="70%" ref="strategyRouteConfigVisible">
        <span style="color: #f5222d;">注意：如果定制了策略组查找案子，不能开启此功能，比如“得物营销”</span>
        <div>
          <el-form size="small" label-width="100px">
            <el-table :data="groupRouteList" style="width: 100%">
                <el-table-column prop="groupName" label="策略组名字" min-width="180"/>
                <el-table-column label="权重" min-width="180">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="!scope.row.status"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="是否路由">
                  <template slot-scope="scope">
                    <el-switch
                      :value="scope.row.status"
                      v-model="scope.row.status"
                      active-color="#f6ac19"
                      inactive-color="#282828">
                    </el-switch>
                  </template>
                </el-table-column>
              </el-table>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="strategyRouteConfigVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveStrategyRouteConfig" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 添加策略组 -->
      <el-dialog
        title="添加策略组"
        :visible.sync="addStrategyVisible"
        width="40%">
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="策略组名称">
              <el-input placeholder="请输入名称" v-model="addStrategyGroupReq.groupName"></el-input>
            </el-form-item>
             <el-form-item label="来源策略组公司">
              <el-select v-model="addStrategyGroupReq.sourceCompanyId" placeholder="请选择" @change="sourceCompanyChange" style="width: 100%;" filterable>
                <el-option
                  v-for="item in company.companyOption"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="来源策略组名称">
              <el-select v-model="addStrategyGroupReq.sourceGroupId" @change="addStrategyOfChangeSendWay()" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in sourceGroup.groupOption"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首发发送方式">
              <el-select v-model="addStrategyGroupReq.sendWay" @change="addStrategyOfChangeSendWay()" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in firstSendWays"
                  :key="item.ccChannel"
                  :label="item.channelName"
                  :value="item.ccChannel">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首发模版">
              <el-select v-model="addStrategyGroupReq.sendTemplateId" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in templateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  <template>
                    <el-tooltip placement="top" effect="light">
                      <div v-if="internationalVersionFlag == 1 && (addStrategyGroupReq.sendWay === 'C' || addStrategyGroupReq.sendWay === 'I' || addStrategyGroupReq.sendWay === 'N' || addStrategyGroupReq.sendWay === '0') && languageSelect === '0'" slot="content" v-html="item.contentShowTrans || item.contentShow"></div>
                      <div v-else-if="internationalVersionFlag == 1 && (addStrategyGroupReq.sendWay === 'C' || addStrategyGroupReq.sendWay === 'I' || addStrategyGroupReq.sendWay === 'N' || addStrategyGroupReq.sendWay === '0')" slot="content" v-html="item.contentShow || item.contentShowTrans"></div>
                      <div v-else slot="content" v-html="item.contentShow === undefined || item.contentShow === null ? item.content : item.contentShow"></div>
                      <span>{{item.name}}</span>
                    </el-tooltip>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>

            <template v-if="this.$hasPerm('B008&14')">
              <el-form-item label="电话前挂短">
                <div class="hf-field">
                  <el-select ref="addHangupBeforeSel" v-model="addStrategyGroupReq.beforeHangupStrategyId" filterable clearable remote placeholder="输入名称检索挂短模板" style="flex:1;" :loading="hangupLoading" @focus="fetchHangupOptions('before')" :remote-method="(q) => fetchHangupOptions('before', q)" @visible-change="onHangupVisible('before', $event)" @change="onHangupChange('before', $event)">
                    <el-option v-for="item in hangupOptions.before" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    <div v-if="hangupHasMore.before" class="hf-load-more" @click.stop="loadMoreHangup('before')">
                      <span v-if="hangupLoadingMore.before"><i class="el-icon-loading"></i> 加载中…</span>
                      <span v-else>滑动到底部自动加载，或点击加载更多</span>
                    </div>
                  </el-select>
                  <el-tooltip v-if="addStrategyGroupReq.beforeHangupStrategyId" placement="top" effect="light">
                    <div slot="content" class="hf-detail">
                      <div class="hf-detail__title">挂短名称：{{ (hangupDetail.before || {}).name || '—' }}</div>
                      <div v-for="(rule, idx) in (hangupDetail.before || {}).rules || []" :key="idx" class="hf-detail__rule">
                        <div class="hf-detail__rule-title">规则 {{ idx + 1 }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.before)">标签类型：{{ viewHangupLabelType(rule.labelType) }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.before)">标签内容：{{ viewHangupLabelValue(rule) }}</div>
                        <div v-if="!hangupHidePhoneStatus(hangupStrategyTypeMap.before)">电话状态：{{ viewHangupMobileStatus(rule.mobileStatus) }}</div>
                        <div>模板名称：{{ viewHangupTemplateName(rule) }}</div>
                        <div>模板内容：<span v-html="viewHangupTemplateContent(rule)"></span></div>
                        <div>是否解除上限：{{ rule.noLimit ? '是' : '否' }}</div>
                      </div>
                    </div>
                    <i class="el-icon-search hf-detail-icon"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
              <el-form-item label="电话中挂短">
                <div class="hf-field">
                  <el-select ref="addHangupDuringSel" v-model="addStrategyGroupReq.duringHangupStrategyId" filterable clearable remote placeholder="输入名称检索挂短模板" style="flex:1;" :loading="hangupLoading" @focus="fetchHangupOptions('during')" :remote-method="(q) => fetchHangupOptions('during', q)" @visible-change="onHangupVisible('during', $event)" @change="onHangupChange('during', $event)">
                    <el-option v-for="item in hangupOptions.during" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    <div v-if="hangupHasMore.during" class="hf-load-more" @click.stop="loadMoreHangup('during')">
                      <span v-if="hangupLoadingMore.during"><i class="el-icon-loading"></i> 加载中…</span>
                      <span v-else>滑动到底部自动加载，或点击加载更多</span>
                    </div>
                  </el-select>
                  <el-tooltip v-if="addStrategyGroupReq.duringHangupStrategyId" placement="top" effect="light">
                    <div slot="content" class="hf-detail">
                      <div class="hf-detail__title">挂短名称：{{ (hangupDetail.during || {}).name || '—' }}</div>
                      <div v-for="(rule, idx) in (hangupDetail.during || {}).rules || []" :key="idx" class="hf-detail__rule">
                        <div class="hf-detail__rule-title">规则 {{ idx + 1 }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.during)">标签类型：{{ viewHangupLabelType(rule.labelType) }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.during)">标签内容：{{ viewHangupLabelValue(rule) }}</div>
                        <div v-if="!hangupHidePhoneStatus(hangupStrategyTypeMap.during)">电话状态：{{ viewHangupMobileStatus(rule.mobileStatus) }}</div>
                        <div>模板名称：{{ viewHangupTemplateName(rule) }}</div>
                        <div>模板内容：<span v-html="viewHangupTemplateContent(rule)"></span></div>
                        <div>是否解除上限：{{ rule.noLimit ? '是' : '否' }}</div>
                      </div>
                    </div>
                    <i class="el-icon-search hf-detail-icon"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
              <el-form-item label="电话后挂短">
                <div class="hf-field">
                  <el-select ref="addHangupAfterSel" v-model="addStrategyGroupReq.afterHangupStrategyId" filterable clearable remote placeholder="输入名称检索挂短模板" style="flex:1;" :loading="hangupLoading" @focus="fetchHangupOptions('after')" :remote-method="(q) => fetchHangupOptions('after', q)" @visible-change="onHangupVisible('after', $event)" @change="onHangupChange('after', $event)">
                    <el-option v-for="item in hangupOptions.after" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    <div v-if="hangupHasMore.after" class="hf-load-more" @click.stop="loadMoreHangup('after')">
                      <span v-if="hangupLoadingMore.after"><i class="el-icon-loading"></i> 加载中…</span>
                      <span v-else>滑动到底部自动加载，或点击加载更多</span>
                    </div>
                  </el-select>
                  <el-tooltip v-if="addStrategyGroupReq.afterHangupStrategyId" placement="top" effect="light">
                    <div slot="content" class="hf-detail">
                      <div class="hf-detail__title">挂短名称：{{ (hangupDetail.after || {}).name || '—' }}</div>
                      <div v-for="(rule, idx) in (hangupDetail.after || {}).rules || []" :key="idx" class="hf-detail__rule">
                        <div class="hf-detail__rule-title">规则 {{ idx + 1 }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.after)">标签类型：{{ viewHangupLabelType(rule.labelType) }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.after)">标签内容：{{ viewHangupLabelValue(rule) }}</div>
                        <div v-if="!hangupHidePhoneStatus(hangupStrategyTypeMap.after)">电话状态：{{ viewHangupMobileStatus(rule.mobileStatus) }}</div>
                        <div>模板名称：{{ viewHangupTemplateName(rule) }}</div>
                        <div>模板内容：<span v-html="viewHangupTemplateContent(rule)"></span></div>
                        <div>是否解除上限：{{ rule.noLimit ? '是' : '否' }}</div>
                      </div>
                    </div>
                    <i class="el-icon-search hf-detail-icon"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
            </template>
            <el-form-item label="每日短信上限">
              <el-input placeholder="请输入每日短信上限数量" v-model="addStrategyGroupReq.msgCeiling"></el-input>
            </el-form-item>
            <el-form-item label="每日语音接听上限">
              <el-input placeholder="请输入每日语音接听上限数量" v-model="addStrategyGroupReq.ivrCeiling"></el-input>
            </el-form-item>
            <el-form-item label="计算机器人接听:" v-if="this.$partB()">
              <el-tooltip content="接听上限是否剔除机器人接听" placement="top">
                <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
              <el-switch v-model="addStrategyGroupReq.isCalculateRobot" active-color="#f6ac19" inactive-color="#282828">
              </el-switch>
              <el-input-number v-if="addStrategyGroupReq.isCalculateRobot" v-model="addStrategyGroupReq.robotLimitNum"   :min="0" :step="1" label="机器人接听上限"></el-input-number>
            </el-form-item>
            <el-form-item label="计算接通时长(秒)">
                <el-tooltip content="1.接听上限剔除接通时长范围,如配置为10,则接听上限中剔除接通时长为0-10秒(含)的轮次；2.配置为0或者为空,则不做剔除" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
                </el-tooltip>
                <el-input-number  v-model="addStrategyGroupReq.answerDuration"   :min="0" :step="1"  ></el-input-number>
            </el-form-item>
            <el-form-item label="每日语音发送上限">
              <el-input placeholder="请输入每日语音发送上限数量" v-model="addStrategyGroupReq.ivrSendCeiling"></el-input>
            </el-form-item>
            <el-form-item label="场景语音请求超时时间(秒):" v-if="this.$partB()">
              <el-input v-model="addStrategyGroupReq.sceneTimeout" type="number" min="20" max="90" placeholder="请输入场景语音请求超时时间20-90"></el-input>
            </el-form-item>
            <el-form-item label="周期委托作业上限">
              <el-tooltip content="用于设置多天语音/短信上限" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
              <el-switch
                v-model="addStrategyGroupReq.isCycleWork"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <template v-if="addStrategyGroupReq.isCycleWork">
              <el-form-item label="周期短信发送上限">
                <el-input placeholder="请输入周期短信发送上限数量" v-model="addStrategyGroupReq.cycleMsgCeiling"></el-input>
              </el-form-item>
              <el-form-item label="周期语音接听上限">
                <el-input placeholder="请输入周期语音接听上限数量" v-model="addStrategyGroupReq.cycleIvrCeiling"></el-input>
              </el-form-item>
              <el-form-item label="周期语音发送上限">
                <el-input placeholder="请输入周期语音发送上限数量" v-model="addStrategyGroupReq.cycleIvrSendCeiling"></el-input>
              </el-form-item>
              <el-form-item label="周期剔除机器人接听">
                <el-tooltip content="接听上限是否剔除机器人接听" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
                <el-switch
                  v-model="addStrategyGroupReq.cycleIsCalculateRobot"
                  active-color="#f6ac19"
                  inactive-color="#282828">
                </el-switch>
              </el-form-item>
              <el-form-item label="周期剔除接通时长(秒)">
                <el-tooltip content="1.接听上限剔除接通时长范围,如配置为10,则接听上限中剔除接通时长为0-10秒(含)的轮次；2.配置为0或者为空,则不做剔除" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
                </el-tooltip>
                <el-input-number v-model="addStrategyGroupReq.cycleAnswerDuration" :min="0" :step="1"></el-input-number>
              </el-form-item>
            </template>
            <el-form-item label="场景语音限频(秒):" v-if="this.$partB()">
              <el-input v-model="addStrategyGroupReq.sceneQps" type="number" min="0.05" max="500" placeholder="10代表每秒10个请求,0.05~500"></el-input>
            </el-form-item>
            <el-form-item label="是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="addStrategyGroupReq.isRetry"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="重呼次数:" v-if="this.$partB() && addStrategyGroupReq.isRetry">
              <el-input v-model="addStrategyGroupReq.retryCount" type="number" :min="0" :max="24" placeholder="请输入重呼次数"></el-input>
            </el-form-item>
            <el-form-item label="重呼间隔（分钟）:" v-if="this.$partB() && addStrategyGroupReq.isRetry">
              <el-input v-model="addStrategyGroupReq.retryInterval" type="number" :min="0" placeholder="请输入重呼间隔（分钟）"></el-input>
            </el-form-item>
            <el-form-item label="重呼条件:" v-if="this.$partB() && addStrategyGroupReq.isRetry">
              <el-input v-model="addStrategyGroupReq.retryCondition" type="textarea" :rows="2"  placeholder="请输入重呼条件，多个条件分号隔开"></el-input>
            </el-form-item>
            <el-form-item label="ivr是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="addStrategyGroupReq.ivrIsRetry"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="ivr重呼次数:" v-if="this.$partB() && addStrategyGroupReq.ivrIsRetry">
              <el-input v-model="addStrategyGroupReq.ivrRetryCount" type="number" :min="0" :max="24" placeholder="请输入ivr重呼次数"></el-input>
            </el-form-item>
            <el-form-item label="ivr重呼条件:" v-if="this.$partB() && addStrategyGroupReq.ivrIsRetry">
              <el-input v-model="addStrategyGroupReq.ivrRetryCondition" type="textarea" :rows="2"  placeholder="请输入ivr重呼条件，多个条件分号隔开"></el-input>
            </el-form-item>
            <el-form-item label="短信是否重发:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch v-model="addStrategyGroupReq.msgIsRetry" active-color="#f6ac19" inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="短信重发次数:" v-if="this.$partB() && addStrategyGroupReq.msgIsRetry">
              <el-input v-model="addStrategyGroupReq.msgRetryCount" type="number" :min="0" :max="24" placeholder="请输入短信重发次数"></el-input>
            </el-form-item>
            <!-- <el-form-item label="短信重发时短信状态:" v-if="this.$partB() && addStrategyGroupReq.msgIsRetry">
              <el-select multiple v-model="msgIsRetryLabelData" placeholder="请选择" style="width: 100%;" >
                  <el-option
                    v-for="item in msgRetryStatusTypes"
                    :key="item.modelCode"
                    :label="item.modelName"
                    :value="item.modelCode">
                  </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="短信重发时效:" v-if="this.$partB() && addStrategyGroupReq.msgIsRetry">
                <el-input v-model="addStrategyGroupReq.msgRetryEffectiveTime" type="number" :min="0" max="1000000" placeholder="请输入短信重发时效">分钟</el-input>
            </el-form-item>
            <el-form-item label="是否开启mock:" v-if="this.$hasPerm('B008&12-1')">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="mockConfInfo.isMock"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="电话状态:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">
              <el-input v-model="mockConfInfo.mobileStatus" type="textarea" :rows="2" placeholder="请输入电话状态，多个条件封号隔开"></el-input>
            </el-form-item>
            <el-form-item label="mock的万分比:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">
              <el-input v-model="mockConfInfo.rate" type="number" min="0" max="10000" placeholder="请输入mock百分比0-10000"></el-input>
            </el-form-item>
            <el-form-item label="最大接听率:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">
              <el-input v-model="mockConfInfo.maxAnswerRate" type="number" min="0" max="100" placeholder="请输入最大接听率百分比0-100"></el-input>
            </el-form-item>
            <el-form-item label="是否mock详情:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="mockConfInfo.isConfDetails"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
              <el-button type="primary" style="margin-bottom: 20px; margin-left: 60%;" size="mini" round @click="addRow" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isConfDetails">添加句</el-button>
              <template v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isConfDetails">
                <div>
                  <el-table :data="mockConfInfo.confDetails" style="width: 100%">
                    <el-table-column prop="number" label="句序" width="100"></el-table-column>
                    <el-table-column prop="weight" label="权重" width="150">
                      <template slot-scope="scope">
                        <el-input-number :min="1" :max="100" v-model="scope.row.weight"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button type="text" @click="deleteRow(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="预测试外呼配置:" v-if="this.$partB()">
              <el-input v-model="addStrategyGroupReq.pretestConf" type="textarea" :rows="2" placeholder="请输入预测试外呼配置"></el-input>
            </el-form-item>
            <el-form-item label="使用的关键字:" v-if="this.$partB()">
              <el-input v-model="addStrategyGroupReq.keywords" type="textarea" :rows="2" placeholder="请输入使用的关键字"></el-input>
            </el-form-item>
            <el-form-item label="条件路由" v-if="this.$hasPerm('B033&1')">
              <el-select v-model="addStrategyGroupReq.routeConId" placeholder="请选择" style="width: 100%;" filterable clearable>
                <el-option
                  v-for="item in routeConOption"
                  :key="item.id"
                  :label="item.confName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否使用分支模板">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="addStrategyGroupReq.whetherUseBranchTemplate"
                :active-value="1"
                :inactive-value="0"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addStrategyVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="addStrategyGroup" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 编辑策略组 -->
      <el-dialog
        title="编辑策略组"
        :visible.sync="updateGroupVisible"
        width="40%">
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="策略组名称">
              <el-input v-if="updateGroupReq.groupName === '主策略' || updateGroupReq.groupName === '主策略组'" placeholder="请输入策略组名称" v-model="updateGroupReq.groupName" :disabled="true"></el-input>
              <el-input v-else placeholder="请输入策略组名称" v-model="updateGroupReq.groupName"></el-input>
            </el-form-item>
            <el-form-item label="首发发送方式">
              <el-select v-model="updateGroupReq.sendWay" @change="updateStrategyOfChangeSendWay()" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in firstSendWays"
                  :key="item.ccChannel"
                  :label="item.channelName"
                  :value="item.ccChannel">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首发模版">
              <el-select v-model="updateGroupReq.sendTemplateId" placeholder="请选择" style="width: 100%;" clearable  filterable>
                <el-option
                  v-for="item in templateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  <template>
                    <el-tooltip placement="top" effect="light">
                      <div v-if="internationalVersionFlag == 1 && (updateGroupReq.sendWay === 'C' || updateGroupReq.sendWay === 'I' || updateGroupReq.sendWay === 'N' || addStrategyGroupReq.sendWay === '0') && languageSelect === '0'" slot="content" v-html="item.contentShowTrans || item.contentShow"></div>
                      <div v-else-if="internationalVersionFlag == 1 && (updateGroupReq.sendWay === 'C' || updateGroupReq.sendWay === 'I' || updateGroupReq.sendWay === 'N' || addStrategyGroupReq.sendWay === '0')" slot="content" v-html="item.contentShow || item.contentShowTrans"></div>
                      <div v-else slot="content" v-html="item.contentShow ? item.contentShow : item.content"></div>
                      <span>{{item.name}}</span>
                    </el-tooltip>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>

            <template v-if="this.$hasPerm('B008&14')">
              <el-form-item label="首发电话前挂短">
                <div class="hf-field">
                  <el-select ref="editHangupBeforeSel" v-model="updateGroupReq.beforeHangupStrategyId" filterable clearable remote placeholder="输入名称检索挂短模板" style="flex:1;" :loading="hangupLoading" @focus="fetchHangupOptions('before')" :remote-method="(q) => fetchHangupOptions('before', q)" @visible-change="onHangupVisible('before', $event)" @change="onHangupChange('before', $event)">
                    <el-option v-for="item in hangupOptions.before" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    <div v-if="hangupHasMore.before" class="hf-load-more" @click.stop="loadMoreHangup('before')">
                      <span v-if="hangupLoadingMore.before"><i class="el-icon-loading"></i> 加载中…</span>
                      <span v-else>滑动到底部自动加载，或点击加载更多</span>
                    </div>
                  </el-select>
                  <el-tooltip v-if="updateGroupReq.beforeHangupStrategyId" placement="top" effect="light">
                    <div slot="content" class="hf-detail">
                      <div class="hf-detail__title">挂短名称：{{ (hangupDetail.before || {}).name || '—' }}</div>
                      <div v-for="(rule, idx) in (hangupDetail.before || {}).rules || []" :key="idx" class="hf-detail__rule">
                        <div class="hf-detail__rule-title">规则 {{ idx + 1 }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.before)">标签类型：{{ viewHangupLabelType(rule.labelType) }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.before)">标签内容：{{ viewHangupLabelValue(rule) }}</div>
                        <div v-if="!hangupHidePhoneStatus(hangupStrategyTypeMap.before)">电话状态：{{ viewHangupMobileStatus(rule.mobileStatus) }}</div>
                        <div>模板名称：{{ viewHangupTemplateName(rule) }}</div>
                        <div>模板内容：<span v-html="viewHangupTemplateContent(rule)"></span></div>
                        <div>是否解除上限：{{ rule.noLimit ? '是' : '否' }}</div>
                      </div>
                    </div>
                    <i class="el-icon-search hf-detail-icon"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
              <el-form-item label="首发电话中挂短">
                <div class="hf-field">
                  <el-select ref="editHangupDuringSel" v-model="updateGroupReq.duringHangupStrategyId" filterable clearable remote placeholder="输入名称检索挂短模板" style="flex:1;" :loading="hangupLoading" @focus="fetchHangupOptions('during')" :remote-method="(q) => fetchHangupOptions('during', q)" @visible-change="onHangupVisible('during', $event)" @change="onHangupChange('during', $event)">
                    <el-option v-for="item in hangupOptions.during" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    <div v-if="hangupHasMore.during" class="hf-load-more" @click.stop="loadMoreHangup('during')">
                      <span v-if="hangupLoadingMore.during"><i class="el-icon-loading"></i> 加载中…</span>
                      <span v-else>滑动到底部自动加载，或点击加载更多</span>
                    </div>
                  </el-select>
                  <el-tooltip v-if="updateGroupReq.duringHangupStrategyId" placement="top" effect="light">
                    <div slot="content" class="hf-detail">
                      <div class="hf-detail__title">挂短名称：{{ (hangupDetail.during || {}).name || '—' }}</div>
                      <div v-for="(rule, idx) in (hangupDetail.during || {}).rules || []" :key="idx" class="hf-detail__rule">
                        <div class="hf-detail__rule-title">规则 {{ idx + 1 }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.during)">标签类型：{{ viewHangupLabelType(rule.labelType) }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.during)">标签内容：{{ viewHangupLabelValue(rule) }}</div>
                        <div v-if="!hangupHidePhoneStatus(hangupStrategyTypeMap.during)">电话状态：{{ viewHangupMobileStatus(rule.mobileStatus) }}</div>
                        <div>模板名称：{{ viewHangupTemplateName(rule) }}</div>
                        <div>模板内容：<span v-html="viewHangupTemplateContent(rule)"></span></div>
                        <div>是否解除上限：{{ rule.noLimit ? '是' : '否' }}</div>
                      </div>
                    </div>
                    <i class="el-icon-search hf-detail-icon"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
              <el-form-item label="首发电话后挂短">
                <div class="hf-field">
                  <el-select ref="editHangupAfterSel" v-model="updateGroupReq.afterHangupStrategyId" filterable clearable remote placeholder="输入名称检索挂短模板" style="flex:1;" :loading="hangupLoading" @focus="fetchHangupOptions('after')" :remote-method="(q) => fetchHangupOptions('after', q)" @visible-change="onHangupVisible('after', $event)" @change="onHangupChange('after', $event)">
                    <el-option v-for="item in hangupOptions.after" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    <div v-if="hangupHasMore.after" class="hf-load-more" @click.stop="loadMoreHangup('after')">
                      <span v-if="hangupLoadingMore.after"><i class="el-icon-loading"></i> 加载中…</span>
                      <span v-else>滑动到底部自动加载，或点击加载更多</span>
                    </div>
                  </el-select>
                  <el-tooltip v-if="updateGroupReq.afterHangupStrategyId" placement="top" effect="light">
                    <div slot="content" class="hf-detail">
                      <div class="hf-detail__title">挂短名称：{{ (hangupDetail.after || {}).name || '—' }}</div>
                      <div v-for="(rule, idx) in (hangupDetail.after || {}).rules || []" :key="idx" class="hf-detail__rule">
                        <div class="hf-detail__rule-title">规则 {{ idx + 1 }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.after)">标签类型：{{ viewHangupLabelType(rule.labelType) }}</div>
                        <div v-if="!hangupHideLabelFields(hangupStrategyTypeMap.after)">标签内容：{{ viewHangupLabelValue(rule) }}</div>
                        <div v-if="!hangupHidePhoneStatus(hangupStrategyTypeMap.after)">电话状态：{{ viewHangupMobileStatus(rule.mobileStatus) }}</div>
                        <div>模板名称：{{ viewHangupTemplateName(rule) }}</div>
                        <div>模板内容：<span v-html="viewHangupTemplateContent(rule)"></span></div>
                        <div>是否解除上限：{{ rule.noLimit ? '是' : '否' }}</div>
                      </div>
                    </div>
                    <i class="el-icon-search hf-detail-icon"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
            </template>
            <el-form-item label="每日短信上限">
              <el-input placeholder="请输入每日短信上限数量" v-model="updateGroupReq.msgCeiling"></el-input>
            </el-form-item>
            <el-form-item label="每日语音接听上限">
              <el-input placeholder="请输入每日语音接听上限数量" v-model="updateGroupReq.ivrCeiling"></el-input>
            </el-form-item>
            <el-form-item label="计算机器人接听:" v-if="this.$partB()">
              <el-tooltip content="接听上限是否剔除机器人接听" placement="top">
                <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
              <el-switch v-model="updateGroupReq.isCalculateRobot" active-color="#f6ac19" inactive-color="#282828">
              </el-switch>
              <el-input-number v-if="updateGroupReq.isCalculateRobot" v-model="updateGroupReq.robotLimitNum"   :min="0" :step="1" label="机器人接听上限"></el-input-number>
            </el-form-item>
            <el-form-item label="计算接通时长(秒):">
                <el-tooltip content="1.接听上限剔除接通时长范围,如配置为10,则接听上限中剔除接通时长为0-10秒(含)的轮次；2.配置为0或者为空,则不做剔除" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
                </el-tooltip>
                <el-input-number  v-model="updateGroupReq.answerDuration"   :min="0" :step="1"  ></el-input-number>
            </el-form-item>
            <el-form-item label="每日语音发送上限">
              <el-input placeholder="请输入每日语音发送上限数量" v-model="updateGroupReq.ivrSendCeiling"></el-input>
            </el-form-item>
            <el-form-item label="场景语音请求超时时间(秒):" v-if="this.$partB()">
              <el-input v-model="updateGroupReq.sceneTimeout" type="number" min="20" max="90" placeholder="请输入场景语音请求超时时间20-90"></el-input>
            </el-form-item>
            <el-form-item label="周期委托作业上限">
              <el-tooltip content="用于设置多天语音/短信上限" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
              <el-switch
                v-model="updateGroupReq.isCycleWork"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <template v-if="updateGroupReq.isCycleWork">
              <el-form-item label="周期短信发送上限">
                <el-input placeholder="请输入周期短信发送上限数量" v-model="updateGroupReq.cycleMsgCeiling"></el-input>
              </el-form-item>
              <el-form-item label="周期语音接听上限">
                <el-input placeholder="请输入周期语音接听上限数量" v-model="updateGroupReq.cycleIvrCeiling"></el-input>
              </el-form-item>
              <el-form-item label="周期语音发送上限">
                <el-input placeholder="请输入周期语音发送上限数量" v-model="updateGroupReq.cycleIvrSendCeiling"></el-input>
              </el-form-item>
              <el-form-item label="周期剔除机器人接听">
                <el-tooltip content="周期内语音接听上限是否剔除机器人接听" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
                </el-tooltip>
                <el-switch
                  v-model="updateGroupReq.cycleIsCalculateRobot"
                  active-color="#f6ac19"
                  inactive-color="#282828">
                </el-switch>
              </el-form-item>
              <el-form-item label="周期剔除接通时长(秒)">
                <el-tooltip content="1.周期内语音接听上限剔除接通时长范围,如配置为10,则周期内语音接听上限中剔除接通时长为0-10秒(含)的轮次；2.配置为0或者为空,则不做剔除" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
                </el-tooltip>
                <el-input-number v-model="updateGroupReq.cycleAnswerDuration" :min="0" :step="1"></el-input-number>
              </el-form-item>
            </template>
            <el-form-item label="场景语音限频(秒):" v-if="this.$partB()">
              <el-input v-model="updateGroupReq.sceneQps" type="number" min="0.05" max="500" placeholder="10代表每秒10个请求,0.05~500"></el-input>
            </el-form-item>
            <el-form-item label="是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="updateGroupReq.isRetry"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="未振铃:" v-if="this.$partB() && updateGroupReq.isRetry">
              <el-tooltip content="只允许未振铃重呼" placement="top">
                <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
              <el-switch
                v-model="updateGroupReq.retryNoRingtone"
                :active-value="1"
                :inactive-value="0"
                active-text="开启"
                inactive-text="关闭">
              </el-switch>
            </el-form-item>
            <el-form-item label="重呼次数:" v-if="this.$partB() && updateGroupReq.isRetry">
              <el-input v-model="updateGroupReq.retryCount" type="number" :min="0" :max="24" placeholder="请输入重呼次数"></el-input>
            </el-form-item>
            <el-form-item label="重呼间隔（分钟）:" v-if="this.$partB() && updateGroupReq.isRetry">
              <el-input v-model="updateGroupReq.retryInterval" type="number" :min="0" placeholder="请输入重呼间隔（分钟）"></el-input>
            </el-form-item>
            <el-form-item label="重呼条件:" v-if="this.$partB() && updateGroupReq.isRetry">
              <el-input v-model="updateGroupReq.retryCondition" type="textarea" :rows="2"  placeholder="请输入重呼条件，多个条件分号隔开"></el-input>
            </el-form-item>
            <el-form-item label="ivr是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="updateGroupReq.ivrIsRetry"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="ivr重呼次数:" v-if="this.$partB() && updateGroupReq.ivrIsRetry">
              <el-input v-model="updateGroupReq.ivrRetryCount" type="number" :min="0" :max="24" placeholder="请输入ivr重呼次数"></el-input>
            </el-form-item>
            <el-form-item label="ivr重呼条件:" v-if="this.$partB() && updateGroupReq.ivrIsRetry">
              <el-input v-model="updateGroupReq.ivrRetryCondition" type="textarea" :rows="2"  placeholder="请输入ivr重呼条件，多个条件分号隔开"></el-input>
            </el-form-item>
              <el-form-item label="短信是否重发:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
                <el-switch v-model="updateGroupReq.msgIsRetry" active-color="#f6ac19" inactive-color="#282828">
                </el-switch>
              </el-form-item>
              <el-form-item label="短信重发次数:" v-if="this.$partB() && updateGroupReq.msgIsRetry">
                <el-input v-model="updateGroupReq.msgRetryCount" type="number" :min="0" :max="24" placeholder="请输入短信重发次数"></el-input>
              </el-form-item>
              <!-- <el-form-item label="短信重发时短信状态:" v-if="this.$partB() && updateGroupReq.msgIsRetry">
                <el-select v-model="msgIsRetryLabelData" multiple placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in msgRetryStatusTypes"
                      :key="item.modelCode"
                      :label="item.modelName"
                      :value="item.modelCode">
                    </el-option>
                  </el-select>
              </el-form-item> -->
              <el-form-item label="短信重发时效:" v-if="this.$partB() && updateGroupReq.msgIsRetry">
                  <el-input v-model="updateGroupReq.msgRetryEffectiveTime" type="number" :min="0" max="1000000" placeholder="请输入短信重发时效">分钟</el-input>
              </el-form-item>
            <el-form-item label="是否开启mock:" v-if="this.$hasPerm('B008&12-1')">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="mockConfInfo.isMock"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="电话状态:" v-if="mockConfInfo.isMock && this.$hasPerm('B008&12-1')">
              <el-input v-model="mockConfInfo.mobileStatus" type="textarea" :rows="2" placeholder="请输入电话状态，多个条件封号隔开"></el-input>
            </el-form-item>
            <el-form-item label="mock的万分比:" v-if="mockConfInfo.isMock  && this.$hasPerm('B008&12-1')">
              <el-input v-model="mockConfInfo.rate" type="number" min="0" max="10000" placeholder="请输入mock百分比0-10000"></el-input>
            </el-form-item>
            <el-form-item label="最大接听率:" v-if="mockConfInfo.isMock && this.$hasPerm('B008&12-1')">
              <el-input v-model="mockConfInfo.maxAnswerRate" type="number" min="0" max="100" placeholder="请输入最大接听率百分比0-100"></el-input>
            </el-form-item>
            <el-form-item label="是否mock详情:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="mockConfInfo.isConfDetails"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
              <el-button type="primary" style="margin-bottom: 20px; margin-left: 60%;" size="mini" round @click="addRow" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isConfDetails">添加句</el-button>
              <template v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isConfDetails">
                <div>
                  <el-table :data="mockConfInfo.confDetails" style="width: 100%">
                    <el-table-column prop="number" label="句序" width="100"></el-table-column>
                    <el-table-column prop="weight" label="权重" width="150">
                      <template slot-scope="scope">
                        <el-input-number :min="1" :max="100" v-model="scope.row.weight"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button type="text" @click="deleteRow(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="预测试外呼配置:" v-if="this.$partB()">
              <el-input v-model="updateGroupReq.pretestConf" type="textarea" :rows="2" placeholder="请输入预测试外呼配置"></el-input>
            </el-form-item>
            <el-form-item label="使用的关键字:" v-if="this.$partB()">
              <el-input v-model="updateGroupReq.keywords" type="textarea" :rows="2" placeholder="请输入使用的关键字"></el-input>
            </el-form-item>
            <el-form-item label="条件路由" v-if="this.$hasPerm('B033&1')">
              <el-select v-model="updateGroupReq.routeConId" placeholder="请选择" style="width: 100%;" filterable clearable>
                <el-option
                  v-for="item in routeConOption"
                  :key="item.id"
                  :label="item.confName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否使用分支模板">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="updateGroupReq.whetherUseBranchTemplate"
                :active-value="1"
                :inactive-value="0"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateGroupVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="updateStrategyGroup" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 更新策略和模板 -->
       <el-dialog
        title="更新策略和模板"
        :visible.sync="updateStrategyVisible"
        width="30%">
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="对象公司">
              <el-select v-model="updateCollectAndTemplateReq.toCompany" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in company.companyOption"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="选择更新方式">
              <el-select v-model="updateCollectAndTemplateReq.changeWay" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in changeWayOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="策略模板来源公司">
              <el-select v-model="updateCollectAndTemplateReq.sourceCompany" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in company.companyOption"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateStrategyVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="updateCollectAndTemplate" size="small">保存</el-button>
        </div>
      </el-dialog>
      <!-- 批量更新模板 -->
      <el-dialog
        title="批量更新模板"
        :visible.sync="updateTemplateVisible"
        width="40%">
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="更新公司">
              <el-select v-model="updateCompany" style="width: 100%;" placeholder="请选择" multiple collapse-tags filterable @change="updateTemplateCompanyChange">
                <el-option
                  v-for="item in company.companyOption"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="策略组">
              <el-select v-model="updateGroupId" style="width: 100%;" multiple collapse-tags filterable placeholder="请选择（非必选项）">
                <el-option
                  v-for="item in groupIdList"
                  :key="item.id"
                  :label="item.companyName + '-' + item.groupName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="原始字段">
              <el-input placeholder="请输入内容" v-model="updateTemplateReq.originalContent"></el-input>
            </el-form-item>
            <el-form-item label="更新字段">
              <el-input placeholder="请输入内容" v-model="updateTemplateReq.updateContent"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateTemplateVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="updateTemplate" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 批量更新模板 -->
      <el-dialog
        title="批量更新模板"
        :visible.sync="submitUpdateTemplateVisible"
        width="40%">
        <div>
          <span>{{updateTemplateMessage}}</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitUpdateTemplateVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="submitUpdateTemplate" size="small">保存</el-button>
        </div>
      </el-dialog>
    </div>
    <add-template ref="addTemplate" :search="search"></add-template>
     <!-- 策略组配置 -->
    <group-config ref="groupConfig" :company="company"></group-config>
  </div>
</template>
<script>
import lodash from 'lodash';
import sendRule from './send_rule';
import voiceTemplateList from './voice_template_list';
import msgTemplateList from './msg_template_list';
import hangupTemplateList from './hangup_template_list';
import caseStatus from './case_status';
import contactStatus from './contact_status';
import labelList from './label_list';
import addTemplate from './add_template';
import strategyOverview from './strategy_overview';
import ivoiceTemplateList from './ivoice_template_list';
import panel from './panel';
import voiceScene from './voice_scene';
import sceneTemplate from './scene_template';
import templateFiled from './template_filed';
import groupConfig from './group_config';

export default {
  data() {
    return {
      activeTab: '策略总览',
      startTime: '',
      updateCompany: [],
      firstSendWays: [],
      company: {
        companySelected: '',
        companyOption: [],
        strategyPoint: ''
      },
      group: {
        groupSelected: '',
        groupOption: []
      },
      sourceGroup: {
        groupSelected: '',
        groupOption: []
      },
      routeConOption: [],
      changeWayOption: [
        {
          value: '0',
          label: '重置主策略及模板'
        },
        {
          value: '1',
          label: '更新主策略及模板'
        },
        {
          value: '2',
          label: '更新主策略模板'
        }
      ],
      otherScore: '',
      score: [25, 50],
      strategyConfigVisible: false,
      strategyRouteConfigVisible: false,
      addStrategyVisible: false,
      updateStrategyVisible: false,
      updateTemplateVisible: false,
      submitUpdateTemplateVisible: false,
      groupReq: {
        companyId: ''
      },
      groupRouteReq: {
        companyId: '',
        groupId: ''
      },
      routeConReq: {
        companyId: ''
      },
      addStrategyGroupReq: {
        companyId: '',
        groupName: '',
        sourceCompanyId: '',
        sourceGroupId: '',
        sendWay: '',
        sendTemplateId: '',
        msgCeiling: null,
        ivrCeiling: null,
        sceneTimeout: 60,
        sceneQps: null,
        isCalculateRobot: null,
        answerDuration: null,
        robotLimitNum: 0,
        ivrSendCeiling: null,
        isRetry: null,
        retryCount: null,
        retryCondition: null,
        ivrIsRetry: null,
        ivrRetryCount: null,
        ivrRetryCondition: null,
        msgIsRetry: true,
        msgRetryCount: 10,
        msgRetryStatus: null,
        msgRetryEffectiveTime: 40,
        keywords: null,
        routeConId: null,
        mockConf: null,
        retryInterval: null,
        pretestConf: null,
        isCycleWork: false,
        cycleMsgCeiling: null,
        cycleIvrCeiling: null,
        cycleIvrSendCeiling: null,
        cycleIsCalculateRobot: false,
        cycleAnswerDuration: null,
        whetherUseBranchTemplate: 0,
        beforeHangupStrategyId: null,
        duringHangupStrategyId: null,
        afterHangupStrategyId: null
      },
      mockConfInfo: {},
      mockConfInfoInit: {
        isMock: false,
        mobileStatus: 'NORMAL_TEMPORARY_FAILURE;UNALLOCATED_NUMBER;CALL_REJECTED;INVALID_NUMBER_FORMAT;SERVICE_NOT_IMPLEMENTED;ORIGINATOR_CANCEL;NO_USER_RESPONSE;RECOVERY_ON_TIMER_EXPIRE;NORMAL_CLEARING;NO_ANSWER;NORMAL_UNSPECIFIED',
        rate: 0,
        maxAnswerRate: 0,
        isConfDetails: false,
        confDetails: []
      },
      updateCollectAndTemplateReq: {
        toCompany: '',
        changeWay: '',
        sourceCompany: ''
      },
      updateTemplateReq: {
        companyIds: '',
        originalContent: '',
        updateContent: ''
      },
      updateTemplateMessage: '',
      groupList: [],
      groupRouteList: [],
      scoreConfList: [],
      saveScoreDeployStrategyReq: {
        groupList: [],
        scoreConfList: [],
        deleteList: []
      },
      queryTemplateReq: {
        type: '',
        groupId: '',
        companyId: ''
      },
      changeStrategyReq: {
        oldMainGroupId: '',
        selectedGroupId: ''
      },
      templateOperType: {
        addMsg: 'addMsg',
        addVoice: 'addVoice',
        addIvoice: 'addIvoice',
        add: 'add',
        edit: 'edit',
        addChildTemplate: 'addChildTemplate',
        addSceneTemplate: 'addSceneTemplate'
      },
      caseStatusOption: [],
      contactStatusOption: [],
      labelOption: [],
      templateMsgOption: [],
      templateVoiceOption: [],
      templateIVoiceOption: [],
      templateSVoiceOption: [],
      templateType: {
        tempTypeMsg: 'msg',
        tempTypeVoice: 'ivr',
        tempTypeIVoice: 'iVoice',
        tempTypeScene: 'svoice'
      },
      templateList: [],
      // 挂短策略（电话前/中/后）：下拉选项、详情、节点映射
      hangupStrategyTypeMap: { before: 1, during: 2, after: 3 },
      hangupFieldMap: { before: 'beforeHangupStrategyId', during: 'duringHangupStrategyId', after: 'afterHangupStrategyId' },
      hangupOptions: { before: [], during: [], after: [] },
      hangupDetail: { before: null, during: null, after: null },
      hangupLoading: false,
      // 挂短下拉分页（滑到底部自动加载下一页 / 点击“加载更多”）
      hangupPage: { before: 1, during: 1, after: 1 },
      hangupHasMore: { before: false, during: false, after: false },
      hangupLoadingMore: { before: false, during: false, after: false },
      hangupName: { before: '', during: '', after: '' },
      mobileStatusOption: [],
      contactStatusType: {
        benrendianhua: 'benrendianhuaContactStatus',
        zhixidianhua: 'zhixidianhuaContactStatus'
      },
      groupIdList: [],
      updateGroupId: [],
      updateGroupVisible: false,
      updateGroupReq: {
        companyId: null,
        groupId: null,
        groupName: null,
        sendWay: null,
        sendTemplateId: null,
        msgCeiling: null,
        ivrCeiling: null,
        sceneTimeout: 60,
        sceneQps: null,
        isCalculateRobot: null,
        answerDuration: null,
        robotLimitNum: 0,
        ivrSendCeiling: null,
        isRetry: null,
        retryCount: null,
        retryCondition: null,
        retryNoRingtone: null,
        ivrIsRetry: null,
        ivrRetryCount: null,
        ivrRetryCondition: null,
        msgIsRetry: null,
        msgRetryCount: 10,
        msgRetryStatus: null,
        msgRetryEffectiveTime: 40,
        keywords: null,
        routeConId: null,
        mockConf: null,
        retryInterval: null,
        pretestConf: null,
        whetherUseBranchTemplate: 0,
        isCycleWork: false,
        cycleMsgCeiling: null,
        cycleIvrCeiling: null,
        cycleIvrSendCeiling: null,
        cycleIsCalculateRobot: false,
        cycleAnswerDuration: null,
        beforeHangupStrategyId: '',
        duringHangupStrategyId: '',
        afterHangupStrategyId: ''
      },
      msgRetryStatusTypes: [],
      msgIsRetryLabelData: [],
      initMsgIsRetryLabelData: [],
      catchLanguageSelect: this.$getLanguageSelect()
    };
  },
  computed: {
    internationalVersionFlag() {
      return this.$getInternationalVersionFlag();
    },
    languageSelect() {
      return this.catchLanguageSelect;
    }
  },
  mounted() {
    this.langChangeHandler = (newLang) => {
      this.catchLanguageSelect = newLang;
    };
    this.$bus.$on('languageSelectChanged', this.langChangeHandler);
    this.getCompanyOptionList();
    // if (this.$hasPerm('B008&4')) this.caseStatusClick();
    if (this.$hasPerm('B008&5')) this.contactStatusClick();
    this.$refs.sendRule.getMobileStatusOption();
    this.getMobileStatusOption();
    this.getFirstSendWay();
    this.initTemplateFiled(this.templateOperType);
    this.getCaseStatusParam();
    this.getContactStatusParam();
    this.getMsgRetryStatusTypes();
    // 因为子组件调父组件，跨了文件，这样写更简单，不需要一级级传方法，但要保证父级的'templateHadChange'唯一
    // window.eventBus.$on('templateHadChange', () => {
    //   this.initTemplateList();
    // });
  },
  beforeDestroy() {
    this.$bus.$off('languageSelectChanged', this.langChangeHandler);
  },
  methods: {
    toshow(activeTab) {
      this.activeTab = activeTab;
    },
    // sendRuleClick() {
    //   this.$refs.sendRule.getSengRuleDataByFirst(this.company.companySelected, this.company.strategyPoint, this.group.groupSelected, 1);
    // },
    voiceTemplateListClick() {
      if (this.$refs.voiceTemplateList) {
        this.$refs.voiceTemplateList.getDataByFirst(this.company.companySelected, this.group.groupSelected, 1);
      }
    },
    sceneTemplateListClick() {
      if (this.$refs.sceneTemplate) {
        this.$refs.sceneTemplate.getDataByFirst(this.company.companySelected, this.group.groupSelected, 1);
      }
    },
    msgTemplateListClick() {
      if (this.$refs.msgTemplateList) {
        this.$refs.msgTemplateList.getDataByFirst(this.company.companySelected, this.group.groupSelected, 1);
      }
    },
    hangupTemplateListClick() {
      if (this.$refs.hangupTemplateList) {
        this.$refs.hangupTemplateList.getDataByFirst(this.company.companySelected, this.group.groupSelected, 1);
      }
    },
    labelListClick() {
      this.$refs.labelList.getDataByFirst(this.company.companySelected, 1);
    },
    caseStatusClick() {
      this.$refs.caseStatus.getDataByFirst(1);
    },
    contactStatusClick() {
      this.$refs.contactStatus.getDataByFirst(1);
    },
    strategyOverviewClick() {
      this.$refs.strategyOverview.getData(this.company.companySelected);
    },
    // 公司列表
    getCompanyOptionList() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        this.company.companyOption = res.data;
        // 获取缓存
        const sessionOverview = JSON.parse(sessionStorage.getItem('strategyOverview'));
        if (sessionOverview === null) {
          this.activeTab = '策略总览';
          this.company.companySelected = this.$account().companyId;
        } else {
          this.activeTab = '策略明细';
          this.company.companySelected = sessionOverview.companyId;
        }
        res.data.forEach((element) => {
          if (element.id === this.company.companySelected) {
            this.company.strategyPoint = element.strategyPoint;
            return false;
          }
          return true;
        });
        this.companyChange();
      });
    },
    getFirstSendWay() {
      this.$ajax({
        url: '/callPlatform/getFirstSendWay',
        method: 'post'
      }).then((res) => {
        this.firstSendWays = res.data.sendWayList;
      });
    },
    companyChange() {
      // 查对应的策略组
      this.groupReq.companyId = this.company.companySelected;
      this.getGroupOptionList(this.groupReq);
      // this.labelListClick();
      this.getLabelParams();
      this.queryAllGroupsOfThisCompany(this.groupReq);

      this.initTemplateFiled(this.templateOperType);
      this.getRouteConOption();
    },
    sourceCompanyChange() {
      this.resetHangupState();
      this.groupReq.companyId = this.addStrategyGroupReq.sourceCompanyId;
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: this.groupReq
      }).then((res) => {
        this.sourceGroup.groupOption = res.data;
        this.addStrategyGroupReq.sourceGroupId = res.data[0].id;
        this.addStrategyOfChangeSendWay();
      });
    },
    strategyConfig() {
      this.strategyConfigVisible = true;
      this.groupList.forEach((item) => {
        if (item.isMain === 1) {
          this.changeSendWay(item);
        } else if (item.isMain !== 1 && item.isMain !== 2) {
          this.changeSendWay(item);
        }
      });
    },
    strategyRouteConfig(item) {
      this.strategyRouteConfigVisible = true;
      this.getGroupRouteList(item);
    },
    getGroupRouteList(item) {
      this.groupRouteList = [];
      this.groupRouteReq.companyId = this.company.companySelected;
      this.groupRouteReq.groupId = item.groupId;
      this.$ajax({
        url: '/strategy/getGroupRouteConfig',
        method: 'POST',
        data: this.groupRouteReq
      }).then((res) => {
        this.groupRouteList = res.data;
      });
    },
    getRouteConOption() {
      this.routeConReq.companyId = this.company.companySelected;
      this.$ajax({
        method: 'get',
        url: '/conditionRoute/listByCompanyId',
        params: this.routeConReq
      }).then((res) => {
        this.routeConOption = res.data;
      });
    },
    saveStrategyRouteConfig() {
      const list = [];
      this.groupRouteList.forEach((item) => {
        if (item.status) {
          list.push(item);
        }
      });
      const reqBody = {
        companyId: this.company.companySelected,
        groupId: this.groupRouteReq.groupId,
        conf: list
      };
      this.$ajax({
        url: '/strategy/saveStrategyRouteConfig',
        data: reqBody,
        prompt: true
      }).then(
        this.strategyRouteConfigVisible = false
      );
    },
    changeSendWay(item) {
      const req = {};
      req.groupId = item.id;
      req.companyId = item.companyId;
      req.type = item.id;
      if (item.sendWay === 'ivr') {
        req.type = 'ivr';
      } else if (item.sendWay === 'ivoice') {
        req.type = 'ivoice';
      } else if (item.sendWay === 'svoice') {
        req.type = 'svoice';
      } else {
        req.type = 'msg';
      }
      if (item.sendWay !== 'svoice') {
        this.$ajax({
          url: '/robotCase/getTemplateByCompanyId',
          data: req
        }).then((res) => {
          item.templateList = res.data;
        });
      } else {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: req
        }).then((res) => {
          item.templateList = res.data;
        });
      }
    },
    addStrategyOfChangeSendWay() {
      this.queryTemplateReq.groupId = this.addStrategyGroupReq.sourceGroupId;
      this.queryTemplateReq.companyId = this.addStrategyGroupReq.sourceCompanyId;
      this.queryTemplateReq.type = 'ivr';
      if (this.addStrategyGroupReq.sendWay === 'ivr') {
        this.queryTemplateReq.type = 'ivr';
      } else if (this.addStrategyGroupReq.sendWay === 'ivoice') {
        this.queryTemplateReq.type = 'ivoice';
      } else if (this.addStrategyGroupReq.sendWay === 'svoice') {
        this.queryTemplateReq.type = 'svoice';
      } else {
        this.queryTemplateReq.type = 'msg';
      }
      if (this.queryTemplateReq.type !== 'svoice') {
        this.$ajax({
          url: '/robotCase/getTemplateByCompanyId',
          data: this.queryTemplateReq
        }).then((res) => {
          this.templateList = res.data;
        });
      } else {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: this.queryTemplateReq
        }).then((res) => {
          this.templateList = res.data;
        });
      }
    },
    getGroupOptionList(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        this.group.groupOption = res.data;
        // 获取缓存
        const sessionOverview = JSON.parse(sessionStorage.getItem('strategyOverview'));
        if (sessionOverview === null) {
          this.group.groupSelected = res.data[0].id;
        } else {
          this.group.groupSelected = sessionOverview.groupId;
          sessionStorage.removeItem('strategyOverview');
        }
        this.sourceGroup.groupOption = res.data;
        this.sourceGroup.groupSelected = res.data[0].id;
        // this.sendRuleClick();
        // this.voiceTemplateListClick();
        // this.msgTemplateListClick();
        this.initTemplateList();
        this.strategyOverviewClick();
      });
    },
    groupChange() {
      // this.sendRuleClick();
      // this.voiceTemplateListClick();
      // this.msgTemplateListClick();
      this.initTemplateList();
    },
    addStrategy(group) {
      if (group) {
        this.addStrategyGroupReq.sourceGroupId = group.groupId;
        this.addStrategyGroupReq.msgCeiling = group.msgCeiling;
        this.addStrategyGroupReq.ivrCeiling = group.ivrCeiling;
        this.addStrategyGroupReq.sceneTimeout = group.sceneTimeout;
        this.addStrategyGroupReq.sceneQps = group.sceneQps;
        this.addStrategyGroupReq.isCalculateRobot = group.isCalculateRobot;
        this.addStrategyGroupReq.answerDuration = group.answerDuration;
        this.addStrategyGroupReq.robotLimitNum = group.robotLimitNum;
        this.addStrategyGroupReq.ivrSendCeiling = group.ivrSendCeiling;
        this.addStrategyGroupReq.isRetry = group.isRetry;
        this.addStrategyGroupReq.retryCount = group.retryCount;
        this.addStrategyGroupReq.retryCondition = group.retryCondition;
        this.addStrategyGroupReq.ivrIsRetry = group.ivrIsRetry;
        this.addStrategyGroupReq.ivrRetryCount = group.ivrRetryCount;
        this.addStrategyGroupReq.ivrRetryCondition = group.ivrRetryCondition;
        this.addStrategyGroupReq.msgIsRetry = group.msgIsRetry;
        this.addStrategyGroupReq.msgRetryStatus = group.msgRetryStatus;
        if (group.msgIsRetry) {
          if (group.msgRetryStatus) {
            this.msgIsRetryLabelData = group.msgRetryStatus.split(',');
          } else {
            this.msgIsRetryLabelData = [];
          }
          this.addStrategyGroupReq.msgRetryEffectiveTime = group.msgRetryEffectiveTime;
          this.addStrategyGroupReq.msgRetryCount = group.msgRetryCount;
        } else {
          this.msgIsRetryLabelData = this.initMsgIsRetryLabelData;
          this.addStrategyGroupReq.msgRetryEffectiveTime = 40;
          this.addStrategyGroupReq.msgRetryCount = 10;
        }
        this.addStrategyGroupReq.keywords = group.keywords;
        this.addStrategyGroupReq.routeConId = group.routeConId;
        this.addStrategyGroupReq.retryInterval = group.retryInterval;
        this.addStrategyGroupReq.pretestConf = group.pretestConf;
        this.fillCycleWorkFields(this.addStrategyGroupReq, group);
        this.addStrategyGroupReq.whetherUseBranchTemplate = group.whetherUseBranchTemplate;
      } else {
        this.msgIsRetryLabelData = this.initMsgIsRetryLabelData;
        this.addStrategyGroupReq.msgRetryEffectiveTime = 40;
        this.addStrategyGroupReq.sourceGroupId = this.group.groupSelected;
        this.addStrategyGroupReq.msgRetryCount = 10;
        this.addStrategyGroupReq.sceneTimeout = 60;
        this.addStrategyGroupReq.isCycleWork = false;
        this.addStrategyGroupReq.cycleMsgCeiling = null;
        this.addStrategyGroupReq.cycleIvrCeiling = null;
        this.addStrategyGroupReq.cycleIvrSendCeiling = null;
        this.addStrategyGroupReq.cycleIsCalculateRobot = false;
        this.addStrategyGroupReq.cycleAnswerDuration = null;
      }
      this.addStrategyGroupReq.sourceCompanyId = this.company.companySelected;
      this.addStrategyGroupReq.companyId = this.company.companySelected;
      this.mockConfInfo = lodash.cloneDeep(this.mockConfInfoInit);
      // 挂短策略字段初始化（场景语音且有已绑定值时回显下拉与详情）
      this.addStrategyGroupReq.beforeHangupStrategyId = group ? (group.beforeHangupStrategyId || '') : '';
      this.addStrategyGroupReq.duringHangupStrategyId = group ? (group.duringHangupStrategyId || '') : '';
      this.addStrategyGroupReq.afterHangupStrategyId = group ? (group.afterHangupStrategyId || '') : '';
      this.resetHangupState();
      if (group) {
        ['before', 'during', 'after'].forEach((slot) => {
          const val = this.addStrategyGroupReq[this.hangupFieldMap[slot]];
          if (val) {
            this.fetchHangupOptions(slot, undefined, 'add');
            this.fetchHangupDetail(slot, val, 'add');
          }
        });
      }
      this.addStrategyVisible = true;
    },
    onRefresList(group) {
      this.addStrategy(group);
    },
    updateGroup(group) {
      this.updateGroupReq.groupId = group.groupId;
      this.updateGroupReq.groupName = group.groupName;
      this.updateGroupReq.sendWay = group.sendWay;
      this.updateGroupReq.companyId = this.company.companySelected;
      this.updateStrategyOfChangeSendWay();
      this.updateGroupReq.sendTemplateId = group.sendTemplateId;
      this.updateGroupReq.msgCeiling = group.msgCeiling;
      this.updateGroupReq.ivrCeiling = group.ivrCeiling;
      this.updateGroupReq.sceneTimeout = group.sceneTimeout;
      this.updateGroupReq.sceneQps = group.sceneQps;
      this.updateGroupReq.isCalculateRobot = group.isCalculateRobot;
      this.updateGroupReq.answerDuration = group.answerDuration;
      this.updateGroupReq.robotLimitNum = group.robotLimitNum;
      this.updateGroupReq.ivrSendCeiling = group.ivrSendCeiling;
      this.updateGroupReq.isRetry = group.isRetry;
      this.updateGroupReq.retryCount = group.retryCount;
      this.updateGroupReq.retryCondition = group.retryCondition;
      this.updateGroupReq.retryNoRingtone = group.retryNoRingtone;
      this.updateGroupReq.ivrIsRetry = group.ivrIsRetry;
      this.updateGroupReq.ivrRetryCount = group.ivrRetryCount;
      this.updateGroupReq.ivrRetryCondition = group.ivrRetryCondition;
      this.updateGroupReq.msgIsRetry = group.msgIsRetry;
      this.updateGroupReq.msgRetryStatus = group.msgRetryStatus;
      this.updateGroupReq.retryInterval = group.retryInterval;
      this.updateGroupReq.pretestConf = group.pretestConf;
      if (group.msgIsRetry) {
        this.updateGroupReq.msgRetryEffectiveTime = group.msgRetryEffectiveTime;
        this.updateGroupReq.msgRetryCount = group.msgRetryCount;
        if (group.msgRetryStatus) {
          this.msgIsRetryLabelData = group.msgRetryStatus.split(',');
        } else {
          this.msgIsRetryLabelData = [];
        }
      } else {
        this.msgIsRetryLabelData = this.initMsgIsRetryLabelData;
        this.updateGroupReq.msgRetryEffectiveTime = 40;
        this.updateGroupReq.msgRetryCount = 10;
      }
      this.updateGroupReq.keywords = group.keywords;
      this.updateGroupReq.routeConId = group.routeConId;
      this.fillCycleWorkFields(this.updateGroupReq, group);
      this.updateGroupReq.whetherUseBranchTemplate = group.whetherUseBranchTemplate;
      if (group.mockConf) {
        this.mockConfInfo = JSON.parse(group.mockConf);
        if (this.mockConfInfo.confDetails === undefined || this.mockConfInfo.confDetails === null) {
          this.mockConfInfo.confDetails = [];
        }
        if (this.mockConfInfo.isMock === undefined || this.mockConfInfo.isMock == null || !this.mockConfInfo.isMock) {
          this.mockConfInfo = lodash.cloneDeep(this.mockConfInfoInit);
        }
      } else {
        this.mockConfInfo = lodash.cloneDeep(this.mockConfInfoInit);
      }

      // 挂短策略字段初始化（场景语音且有已绑定值时回显下拉与详情）
      this.updateGroupReq.beforeHangupStrategyId = group.beforeHangupStrategyId || '';
      this.updateGroupReq.duringHangupStrategyId = group.duringHangupStrategyId || '';
      this.updateGroupReq.afterHangupStrategyId = group.afterHangupStrategyId || '';
      this.resetHangupState();
      // 挂短字段与发送方式无关：任何发送方式的组都按已绑定值回显
      this.initHangupForEdit();

      this.updateGroupVisible = true;
    },
    updateStrategyOfChangeSendWay() {
      this.queryTemplateReq.groupId = this.updateGroupReq.groupId;
      this.queryTemplateReq.companyId = this.company.companySelected;
      this.queryTemplateReq.type = 'ivr';
      if (this.updateGroupReq.sendWay === 'ivr') {
        this.queryTemplateReq.type = 'ivr';
      } else if (this.updateGroupReq.sendWay === 'ivoice') {
        this.queryTemplateReq.type = 'ivoice';
      } else if (this.updateGroupReq.sendWay === 'svoice') {
        this.queryTemplateReq.type = 'svoice';
      } else {
        this.queryTemplateReq.type = 'msg';
      }

      if (this.queryTemplateReq.type !== 'svoice') {
        this.$ajax({
          url: '/robotCase/getTemplateByCompanyId',
          method: 'POST',
          data: this.queryTemplateReq
        }).then((res) => {
          this.templateList = res.data;
        });
      } else {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: this.queryTemplateReq
        }).then((res) => {
          this.templateList = res.data;
        });
      }
      // 挂短字段与发送方式无关：已有绑定值时始终补拉下拉与详情（不随发送方式清空）
      ['before', 'during', 'after'].forEach((slot) => {
        const val = this.updateGroupReq[this.hangupFieldMap[slot]];
        if (val && !this.hangupDetail[slot]) {
          this.fetchHangupOptions(slot, undefined, 'update');
          this.fetchHangupDetail(slot, val, 'update');
        }
      });
    },
    parseTruthyFlag(value) {
      return value === true || value === 1 || value === '1';
    },
    getCycleGroupSource(group) {
      const optionGroup = (this.group.groupOption || []).find(
        g => g.id === group.groupId || g.groupId === group.groupId
      );
      if (!optionGroup) return group;
      const cycleFields = ['isCycleWork', 'cycleMsgCeiling', 'cycleIvrCeiling', 'cycleIvrSendCeiling', 'cycleIsCalculateRobot', 'cycleAnswerDuration'];
      const merged = { ...group };
      cycleFields.forEach((field) => {
        const val = merged[field];
        if (val === null || val === undefined || val === '') {
          merged[field] = optionGroup[field];
        }
      });
      return merged;
    },
    resolveIsCycleWork(group) {
      const { isCycleWork } = group;
      if (isCycleWork === true || isCycleWork === 1 || isCycleWork === '1') {
        return true;
      }
      if (isCycleWork === false || isCycleWork === 0 || isCycleWork === '0') {
        return false;
      }
      return [group.cycleMsgCeiling, group.cycleIvrCeiling, group.cycleIvrSendCeiling, group.cycleAnswerDuration]
        .some(v => v !== null && v !== undefined && v !== '');
    },
    fillCycleWorkFields(target, group) {
      const cycleGroup = this.getCycleGroupSource(group);
      target.isCycleWork = this.resolveIsCycleWork(cycleGroup);
      target.cycleMsgCeiling = cycleGroup.cycleMsgCeiling;
      target.cycleIvrCeiling = cycleGroup.cycleIvrCeiling;
      target.cycleIvrSendCeiling = cycleGroup.cycleIvrSendCeiling;
      target.cycleIsCalculateRobot = this.parseTruthyFlag(cycleGroup.cycleIsCalculateRobot);
      target.cycleAnswerDuration = cycleGroup.cycleAnswerDuration;
    },
    formatCycleWorkFields(req) {
      const data = { ...req };
      data.isCycleWork = !!data.isCycleWork;
      data.cycleIsCalculateRobot = !!data.cycleIsCalculateRobot;
      ['cycleMsgCeiling', 'cycleIvrCeiling', 'cycleIvrSendCeiling', 'cycleAnswerDuration'].forEach((field) => {
        const val = data[field];
        if (val === null || val === undefined || val === '') {
          delete data[field];
        }
      });
      return data;
    },
    addStrategyGroup() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.addStrategyGroupReq.mockConf = JSON.stringify(this.mockConfInfo);
      this.addStrategyGroupReq.msgRetryStatus = this.msgIsRetryLabelData.join(',');
      const data = this.formatCycleWorkFields(this.addStrategyGroupReq);
      // 显式带上 3 个挂短字段，确保一定进入 createGroup 请求体（避免被后续重构误删/漏传）
      data.beforeHangupStrategyId = this.addStrategyGroupReq.beforeHangupStrategyId || null;
      data.duringHangupStrategyId = this.addStrategyGroupReq.duringHangupStrategyId || null;
      data.afterHangupStrategyId = this.addStrategyGroupReq.afterHangupStrategyId || null;
      const uri = '/strategy/createGroup';
      this.$ajax({
        url: uri,
        data,
        prompt: true
      }).then(() => {
        loading.close();
        this.addStrategyVisible = false;
        // 查对应的策略组
        this.groupReq.companyId = this.addStrategyGroupReq.sourceGroupId;
        this.getGroupOptionList(this.groupReq);
      }).catch(() => {
        loading.close();
      });
    },
    updateStrategyGroup() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.updateGroupReq.mockConf = JSON.stringify(this.mockConfInfo);
      if (this.msgIsRetryLabelData) {
        this.updateGroupReq.msgRetryStatus = this.msgIsRetryLabelData.join(',');
      } else {
        this.updateGroupReq.msgRetryStatus = this.initMsgIsRetryLabelData.join(',');
      }
      const data = this.formatCycleWorkFields(this.updateGroupReq);
      // 显式带上 3 个挂短字段，确保一定进入 updateGroup 请求体
      data.beforeHangupStrategyId = this.updateGroupReq.beforeHangupStrategyId || null;
      data.duringHangupStrategyId = this.updateGroupReq.duringHangupStrategyId || null;
      data.afterHangupStrategyId = this.updateGroupReq.afterHangupStrategyId || null;
      const uri = '/strategy/updateGroup';
      this.$ajax({
        url: uri,
        data,
        prompt: true
      }).then(() => {
        loading.close();
        this.updateGroupVisible = false;
        // 查对应的策略组
        this.groupReq.companyId = this.company.companySelected;
        this.getGroupOptionList(this.groupReq);
        // 刷新策略总览数据
        this.$refs.strategyOverview.getGroupData();
      }).catch(() => {
        loading.close();
      });
    },
    // ===== 挂短策略（电话前/中/后）相关 =====
    // 清空下拉选项与已拉取的详情（保留表单字段值本身，由调用方决定是否清空字段）
    resetHangupState() {
      this.hangupOptions = { before: [], during: [], after: [] };
      this.hangupDetail = { before: null, during: null, after: null };
      this.hangupPage = { before: 1, during: 1, after: 1 };
      this.hangupHasMore = { before: false, during: false, after: false };
      this.hangupLoadingMore = { before: false, during: false, after: false };
      this.hangupName = { before: '', during: '', after: '' };
    },
    // 拉取某节点挂短下拉选项：/hangupStrategy/getPage，分页大小 20
    // 业务参数 companyId/groupId 与“首发模版联动查询”取值一致
    // name 可选：remote 搜索时按名称去后端检索（name 为空表示首次/默认拉取）
    // loadMore=true 表示滚动到底部加载下一页（不清空已有选项、page+1）
    fetchHangupOptions(slot, name, ctx, loadMore) {
      const strategyType = this.hangupStrategyTypeMap[slot];
      // ctx 显式指定 'add' / 'update' 时优先使用，避免初始化时 dialog 尚未 visible
      const isAdd = ctx ? ctx === 'add' : this.addStrategyVisible;
      const companyId = isAdd ? this.addStrategyGroupReq.sourceCompanyId : this.company.companySelected;
      const groupId = isAdd ? this.addStrategyGroupReq.sourceGroupId : this.updateGroupReq.groupId;
      if (!companyId) return Promise.resolve();
      if (loadMore) {
        this.hangupPage[slot] += 1;
      } else {
        this.hangupPage[slot] = 1;
        // 非加载更多时重置检索词（聚焦/初始化=拉全量；remote 检索=按 name 过滤）
        this.hangupName[slot] = name || '';
      }
      const page = this.hangupPage[slot];
      const queryName = this.hangupName[slot];
      if (loadMore) this.hangupLoadingMore[slot] = true; else this.hangupLoading = true;
      return this.$ajax({
        url: '/hangupStrategy/getPage',
        method: 'POST',
        data: {
          pageQueryParam: { page, limit: 20 },
          model: {
            strategyType,
            companyId: companyId || undefined,
            groupId: groupId || undefined,
            name: queryName || undefined
          }
        }
      }).then((res) => {
        const list = (res.data && res.data.list) || [];
        const total = (res.data && res.data.totalRecords) || 0;
        if (loadMore) {
          this.hangupOptions[slot] = (this.hangupOptions[slot] || []).concat(list);
        } else {
          this.hangupOptions[slot] = list;
        }
        // 还有下一页时展示“加载更多”
        this.hangupHasMore[slot] = page * 20 < total;
        // 分页可能未含已选 id：确保已选 option 存在，回显名称而非裸 id
        this.ensureSelectedHangupOption(slot, ctx);
      }).catch(() => {
        if (!loadMore) this.hangupOptions[slot] = [];
        this.hangupHasMore[slot] = false;
        // 即使分页拉取失败，也尽量保留已选挂短的名称回显
        this.ensureSelectedHangupOption(slot, ctx);
      }).finally(() => {
        if (loadMore) this.hangupLoadingMore[slot] = false; else this.hangupLoading = false;
      });
    },
    // 确保当前已选挂短 id 在选项列表中始终存在，避免其不在分页第一页时 el-select 回显裸 id。
    // 名称来自详情接口（hangupStrategy/detail/{id}），详情一定会返回名称，故可稳定回显。
    ensureSelectedHangupOption(slot, ctx) {
      const isAdd = ctx ? ctx === 'add' : this.addStrategyVisible;
      const req = isAdd ? this.addStrategyGroupReq : this.updateGroupReq;
      const id = req[this.hangupFieldMap[slot]];
      if (id == null || id === '') return;
      const list = this.hangupOptions[slot] || (this.hangupOptions[slot] = []);
      if (list.some(x => String(x.id) === String(id))) return;
      const name = (this.hangupDetail[slot] && this.hangupDetail[slot].name) || '';
      if (name) {
        list.push({ id, name });
      }
    },
    // 滚动到底部 / 点击“加载更多”时加载下一页
    loadMoreHangup(slot) {
      if (this.hangupLoadingMore[slot] || !this.hangupHasMore[slot]) return;
      const ctx = this.addStrategyVisible ? 'add' : 'update';
      this.fetchHangupOptions(slot, undefined, ctx, true);
    },
    // 下拉展开时绑定滚动容器，触底自动加载下一页（无限滚动）
    onHangupVisible(slot, visible) {
      if (!visible) return;
      this.$nextTick(() => {
        const refName = `${this.addStrategyVisible ? 'add' : 'edit'}Hangup${slot.charAt(0).toUpperCase()}${slot.slice(1)}Sel`;
        const sel = this.$refs[refName];
        if (!sel || !sel.popperElm) return;
        const wrap = sel.popperElm.querySelector('.el-select-dropdown__wrap');
        if (!wrap || wrap.hfLoadMoreBound) return;
        wrap.hfLoadMoreBound = true;
        wrap.addEventListener('scroll', () => {
          if (wrap.scrollTop + wrap.clientHeight >= wrap.scrollHeight - 6) {
            this.loadMoreHangup(slot);
          }
        });
      });
    },
    // 选中挂短后拉取详情（rules 等），用于悬浮展示
    onHangupChange(slot, val) {
      if (!val) {
        this.hangupDetail[slot] = null;
        return;
      }
      this.fetchHangupDetail(slot, val);
    },
    getMobileStatusOption() {
      this.$ajax({
        method: 'GET',
        url: '/dict/list/washResult'
      }).then((res) => {
        this.mobileStatusOption = (res && res.data) || [];
      });
    },
    fetchHangupDetail(slot, id, ctx) {
      return this.$ajax({
        url: `/hangupStrategy/detail/${id}`,
        method: 'GET'
      }).then((res) => {
        const data = (res && res.data) || {};
        this.$set(this.hangupDetail, slot, {
          name: data.name || '',
          rules: (data.rules && data.rules.length) ? data.rules : []
        });
        // 详情返回名称后，确保已选 option 存在（分页未含该 id 时也能回显名称）
        this.ensureSelectedHangupOption(slot, ctx);
        return data;
      }).catch(() => {
        this.$set(this.hangupDetail, slot, { name: '', rules: [] });
        return {};
      });
    },
    // 编辑回显：已绑定挂短时，拉取下拉选项与详情
    initHangupForEdit() {
      ['before', 'during', 'after'].forEach((slot) => {
        const val = this.updateGroupReq[this.hangupFieldMap[slot]];
        if (val) {
          this.fetchHangupOptions(slot, undefined, 'update');
          this.fetchHangupDetail(slot, val, 'update');
        }
      });
    },
    // —— 详情内容解析（参照 send_rule.vue 绑定挂短时带出的明细）——
    hangupHideLabelFields(st) {
      return st === 1 || st === '1';
    },
    hangupHidePhoneStatus(st) {
      return st === 1 || st === '1' || st === 2 || st === '2';
    },
    viewHangupLabelType(val) {
      if (val === 1 || val === '1') return '系统总标签';
      if (val === 2 || val === '2') return '映射标签';
      if (val === 3 || val === '3') return '过程标签';
      return '-';
    },
    viewHangupLabelValue(rule) {
      const v = rule.labelValue;
      if (Array.isArray(v)) return v.length ? v.join('、') : '—';
      if (typeof v === 'string' && v) return v.split(',').join('、');
      return '—';
    },
    viewHangupMobileStatus(val) {
      // 与 send_rule.vue 的 viewMobileStatus 保持一致：按 modelCode → modelName 解析
      let arr = val;
      if (typeof arr === 'string' && arr) arr = arr.split(',').map(s => s.trim()).filter(Boolean);
      if (!arr || !arr.length) return '—';
      return arr.map((code) => {
        const byCode = this.mobileStatusOption.find(o => o.modelCode === code);
        return byCode ? byCode.modelName : code;
      }).join('、');
    },
    // 挂短规则的模板信息全部取详情接口 rules[] 上的内联字段，不再按 templateId 去
    // templateMsgOption 查表（该列表只按页面当前选中的策略组拉取，编辑其它策略组时会查不到）
    // 模板名称：直接取 templateName
    viewHangupTemplateName(rule) {
      const name = (rule && typeof rule === 'object' && rule.templateName) || '';
      return name || '—';
    },
    // 模板内容（HTML 原文，需 v-html 渲染保留格式）：
    // 非国际版 → templateContent
    // 国际版 + 中文 → templateContentTrans 优先，为空用 templateContent
    // 国际版 + 非中文 → templateContent 优先，为空用 templateContentTrans
    viewHangupTemplateContent(rule) {
      if (!rule || typeof rule !== 'object') return '';
      const content = rule.templateContent || '';
      const trans = rule.templateContentTrans || '';
      if (this.internationalVersionFlag !== 1) return content;
      if (this.languageSelect === '0') return trans || content;
      return content || trans;
    },
    updateCollectAndTemplate() {
      const uri = '/strategy/updateCollectAndTemplate';
      this.$ajax({
        url: uri,
        data: this.updateCollectAndTemplateReq,
        prompt: true
      }).then(
        this.updateStrategyVisible = false
      );
    },
    // 批量更新模板获取策略组
    updateTemplateCompanyChange() {
      const search = {};
      search.companyIds = this.updateCompany;
      if (this.updateCompany.length === 0) {
        this.groupIdList = [];
        return;
      }
      this.$ajax({
        url: 'strategy/updateTemplateCompanyChange',
        data: search
      }).then((res) => {
        this.groupIdList = res.data;
      });
    },
    updateTemplate() {
      this.updateTemplateReq.companyIds = this.updateCompany;
      this.updateTemplateReq.groupIds = this.updateGroupId;
      const uri = '/template/getTemplate';
      let msgTypeNum = 0;
      let ivrTypeNum = 0;
      this.$ajax({
        url: uri,
        data: this.updateTemplateReq,
        prompt: true
      }).then((res) => {
        const templates = res.data;
        for (let i = 0; i < templates.length; i++) {
          if (templates[i].type === 'msg') {
            msgTypeNum += templates[i].numType;
          } else if (templates[i].type === 'ivr') {
            ivrTypeNum += templates[i].numType;
          }
        }
        this.updateTemplateMessage = `你将更新${this.updateCompany.length}家公司共${msgTypeNum}个短信模版及${ivrTypeNum}个语音模版，你确认更新吗?`;
        this.updateTemplateVisible = false;
        this.submitUpdateTemplateVisible = true;
      });
    },
    submitUpdateTemplate() {
      this.updateTemplateReq.companyIds = this.updateCompany;
      this.updateTemplateReq.groupIds = this.updateGroupId;
      const uri = '/template/batchUpdate';
      this.$ajax({
        url: uri,
        data: this.updateTemplateReq,
        prompt: true
      }).then(
        this.submitUpdateTemplateVisible = false
      );
    },
    queryAllGroupsOfThisCompany(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsAndScoreInfoByCompanyId',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        const strategyGroups = res.data;
        this.groupList = strategyGroups.groupList;
        this.scoreConfList = strategyGroups.scoreConfList;
      });
    },
    saveStrategyConfig() {
      this.saveScoreDeployStrategyReq.groupList = this.groupList;
      this.saveScoreDeployStrategyReq.scoreConfList = this.scoreConfList;
      this.saveScoreDeployStrategyReq.companyId = this.company.companySelected;
      this.$ajax({
        url: '/strategy/saveScoreDeployStrategy',
        data: this.saveScoreDeployStrategyReq,
        prompt: true
      }).then(
        this.strategyConfigVisible = false
      );
    },
    addStrategyConfig(item) {
      const strategyScore = {
        id: '',
        companyId: item.companyId,
        bindGroupId: item.id,
        groupId: '',
        strategyScore: [0, 100],
        type: 1,
        createUserId: '',
        updateUserId: '',
        createTime: '',
        updateTime: ''
      };
      this.scoreConfList.push(strategyScore);
    },
    deleteStrategyConfig(scoreItem, key) {
      this.scoreConfList.splice(key, 1);
      if (scoreItem.id !== null && scoreItem.id !== '') {
        this.saveScoreDeployStrategyReq.deleteList.push(scoreItem.id);
      }
    },
    delStrategyGroup(groupId) {
      this.$ajax({
        url: '/strategy/delStrategyGroup',
        params: { 'groupId': groupId },
        prompt: true
      }).then(() => {
        this.queryAllGroupsOfThisCompany(this.groupReq);
      });
    },
    synStrategy(groupId) {
      this.changeStrategyReq.selectedGroupId = groupId;
      for (let i = 0; i < this.groupList.length; i++) {
        if (this.groupList[i].isMain === 1) {
          this.changeStrategyReq.oldMainGroupId = this.groupList[i].id;
        }
      }
      this.$ajax({
        url: '/strategy/changeStrategy',
        data: this.changeStrategyReq,
        prompt: true
      }).then(() => {
        this.queryAllGroupsOfThisCompany(this.groupReq);
      });
    },
    generator(name, index) {
      return `${name}${index}`;
    },
    addTemplate() {
      this.addOrEditTemplate(true, this.templateOperType.add, this.company.companySelected, this.group.groupSelected, null);
    },
    addOrEditTemplate(templateVisible, templateOper, companyId, groupId, row) {
      this.$refs.addTemplate.addOrEditTemplate(templateVisible, templateOper, companyId, groupId, row);
    },
    deleteTemplate(id) {
      this.$refs.addTemplate.deleteTemplate(id);
    },
    openAndCloseTemplate(row) {
      this.$refs.addTemplate.openAndCloseTemplate(row);
    },
    openAndCloseSceneTemplate(row) {
      this.$refs.addTemplate.openAndCloseSceneTemplate(row);
    },
    getCaseStatusParam() {
      this.$ajax({
        url: '/dict/getCaseStatusParam',
        method: 'GET'
      }).then((res) => {
        this.caseStatusOption = res.data;
      });
    },
    getContactStatusParam() {
      this.$ajax({
        url: '/dict/getContactStatusParam',
        data: { contactStatusType: this.contactStatusType.benrendianhua },
        method: 'POST'
      }).then((res) => {
        this.contactStatusOption = res.data;
      });
    },
    getMsgRetryStatusTypes() {
      this.$ajax({
        url: '/dict/list/msgRetryStatusType',
        method: 'GET'
      }).then((res) => {
        this.msgRetryStatusTypes = res.data;
        this.initMsgIsRetryLabelData = [];
        if (res.data) {
          res.data.forEach((item) => {
            this.initMsgIsRetryLabelData.push(item.modelCode);
          });
        }
        this.msgIsRetryLabelData = this.initMsgIsRetryLabelData;
      });
    },
    getLabelParams() {
      const req = {
        'companyId': this.company.companySelected
      };
      this.$ajax({
        url: '/label/getLabelParams',
        method: 'POST',
        data: req
      }).then((res) => {
        this.labelOption = res.data;
      });
    },
    search() {
      // 更新一下模板列表
      this.msgTemplateListClick();
      this.voiceTemplateListClick();
      this.sceneTemplateListClick();
      this.hangupTemplateListClick();
    },
    initTemplateList() {
      const reqMsg = {};
      reqMsg.groupId = this.group.groupSelected;
      reqMsg.type = this.templateType.tempTypeMsg;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqMsg
      }).then((res) => {
        this.templateMsgOption = res.data;
      });
      const reqVoice = {};
      reqVoice.groupId = this.group.groupSelected;
      reqVoice.type = this.templateType.tempTypeVoice;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqVoice
      }).then((res) => {
        this.templateVoiceOption = res.data;
      });
      const reqIVoice = {};
      reqIVoice.groupId = this.group.groupSelected;
      reqIVoice.type = this.templateType.tempTypeIVoice;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqIVoice
      }).then((res) => {
        this.templateIVoiceOption = res.data;
      });
      const reqSVoice = {};
      reqSVoice.groupId = this.group.groupSelected;
      reqSVoice.type = this.templateType.tempTypeIVoice;
      this.$ajax({
        url: '/scene/getSceneParam',
        method: 'POST',
        data: reqSVoice
      }).then((res) => {
        this.templateSVoiceOption = res.data;
      });
    },
    initTemplateFiled(templateOperType) {
      console.warn(`${this.company.companySelected}pp`);
      this.$refs.addTemplate.initTemplateFiled(templateOperType, this.company.companySelected);
    },
    groupConfig() {
      this.$refs.groupConfig.addOrEditGroupConfig();
    },
    addRow() {
      const newRow = {
        number: this.mockConfInfo.confDetails.length + 1,
        weight: ''
      };
      this.mockConfInfo.confDetails.push(newRow);
    },
    deleteRow(number) {
      this.mockConfInfo.confDetails.splice(number, 1);
      // 更新序号
      this.mockConfInfo.confDetails.forEach((row, i) => {
        row.number = i + 1;
      });
    }
  },
  components: {
    sendRule,
    contactStatus,
    caseStatus,
    voiceTemplateList,
    msgTemplateList,
    hangupTemplateList,
    labelList,
    addTemplate,
    strategyOverview,
    ivoiceTemplateList,
    panel,
    voiceScene,
    sceneTemplate,
    templateFiled,
    groupConfig
  }
};
</script>
<style lang="less" scoped>
.sc-row {
  margin-bottom: 15px;
  .sc-row__title {
    padding: 5px 0 0 0;
    text-align: right;
    strong {
      font-weight: 600;
    }
  }
  .sc-row__content {
    .send-percent {
      margin-bottom: 5px;
      .percent {
        width: 120px;
        margin: 0 10px;
      }
    }
    .score-table {
      margin: 15px 0;
      table {
        th, td {
          text-align: center;
        }
      }
    }
  }
}
/* 挂短策略：选择框与详情图标同行 */
.hf-field {
  display: flex;
  align-items: center;
}
.hf-detail-icon {
  margin-left: 8px;
  color: #409EFF;
  cursor: pointer;
  font-size: 16px;
}
.hf-detail {
  max-width: 360px;
  line-height: 1.6;
  font-size: 12px;
}
.hf-detail__title {
  font-weight: bold;
  margin-bottom: 6px;
}
.hf-detail__rule {
  border-top: 1px dashed #dcdfe6;
  padding-top: 6px;
  margin-top: 6px;
}
.hf-detail__rule-title {
  font-weight: bold;
  margin-bottom: 4px;
}
.hf-load-more {
  text-align: center;
  color: #409EFF;
  font-size: 12px;
  line-height: 34px;
  cursor: pointer;
  border-top: 1px dashed #ebeef5;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/index.vue